<ol class="breadcrumb">
  <li>
    <a [routerLink]="['/submissions']">
      Submissions
    </a>
      /  Samples
  </li>
</ol>
<div *ngIf="userInfo">
<table aria-describedby="Submission Sample Table" class="table sample-search-table table-striped table-hover">
    <thead>
        <tr>
          <th scope="col" class="review-header"> </th>
          <th scope="col" class="sampleid-header">Sample ID</th>
          <th scope="col" class="test-results-header">Test Results</th>
          <th scope="col" class="status-header">Status</th>
          <th scope="col" class="test-type-header">Test Type</th>
          <th scope="col" class="reporting-center-header">Center Code</th>
        </tr>
      </thead>
      <tbody>
          <tr *ngFor="let sample of activeFileRecordList">
            <td class="review-cell">
                <mat-checkbox color="primary" [checked]="sample.revInd"  (change)="review($event.checked,sample.docidGuid, sample.sampleId)"></mat-checkbox>
            </td>
            <td class="sampleid-cell">
                <div class="sampleid-cell-container">
                    <div class="sample-id-container">
                        <span matTooltip={{sample.sampleId}}  (click)="sample.testTypeCde === 'DSA Antibody' ? displayAntibodySourceDialog(sample.docidGuid, sample.sampleId) : displaySourceDialog(sample.docidGuid, sample.sampleId)">{{sample.sampleId}}</span>
                    </div>
                    <mat-icon [hidden]="!sample.fhirInd" matTooltip="View FHIR ID" svgIcon="fhir" class="material-icons--outline icon fhir" (click)="displayFhirSourceDialog(sample.docidGuid, sample.sampleId)"></mat-icon>
                    <mat-icon [hidden]="!(sample.testTypeCde === 'DSA Antibody')" matTooltip="DSA Antibody Result" svgIcon="fhir_outline" class="material-icons--outline icon fhir"></mat-icon>
                    <mat-icon matTooltip="Copy Sample ID" class="sample-copy icon copy rotate" (click)="copyMessage($event, sample.sampleId)">content_copy</mat-icon>
                </div>
            </td>
            <td class="test-results-cell">
                <a [routerLink]="['/submissions/submission',sample.docidGuid,'sample',sample.sampleId]"><div class="test-results-button"><span class="test-results-count">{{sample.testResults}}</span></div></a>
            </td>
            <td *ngIf="sample.statusCde === 'Success' || (!userInfo.internalUser && sample.statusCde != 'Failed') ; else showErrorIcn" class="sample-status-cell">
                <div class="sample-status">{{sample.statusCde}}</div>
            </td>
            <ng-template #showErrorIcn>
                <td class="sample-status-cell">
                    <mat-icon class="icon info" [hidden]="!sample.statusCde" (click)="displaySrchErrorDialog(sample.docidGuid,sample.sampleId)">error_outline</mat-icon>
                    <div class="status-cell">{{sample.statusCde}}</div>
                </td>
            </ng-template>
            <div *ngIf="sample.testTypeCde==='Blood Group Antigens'; then thenBlock else elseBlock"></div>
                <ng-template #thenBlock><td class="test-type-cell" >BGA</td></ng-template>
                <ng-template #elseBlock><td class="test-type-cell" >{{sample.testTypeCde}}</td></ng-template>
            <td class="reporting-center-cell">{{sample.centerCde}}</td>
        </tr>
        <p class="empty-search" *ngIf="activeFileRecordList != null && activeFileRecordList.length === 0">No results found for search criteria entered</p>
      </tbody>
    </table>
    <div class="table-tools">
      <div class="extract-button" #extractButton (click)="extract(activeFileRecord.uuid)">
        <em class="material-icons file-dwnld">file_download</em>Extract
      </div>
    </div>
</div>
<modal-component #sampleSource
                 [title]="sourceModalTitle"
                 [data]="{
                  resizeOrClose:'close',
                  okBtnTitle:'OK',
                  okBtnCssClass:'btn btn-primary',
                  cancelBtnTitle: '',
                  editBtnTitle: '',
                  resubmitBtnTitle: ''}">
    <div class="hml-sample-source">{{sourceModalContent}}</div>
</modal-component>

<modal-component #sampleFhirSource
                 [title]="sourceModalTitle"
                 [data]="{
                  resizeOrClose:'close',
                  okBtnTitle:'OK',
                  okBtnCssClass:'btn btn-primary',
                  cancelBtnTitle: '',
                  editBtnTitle: '',
                  resubmitBtnTitle: ''
                  }">
    <div class="hml-sample-source"><pre>{{sourceModalContent | json}}</pre></div>
</modal-component>

<modal-component #errorDialog
    [title]="errorModalTitle"
    [data]="{
        resizeOrClose:'close',
        okBtnTitle:'',
        cancelBtnTitle: '',
        editBtnTitle: '',
        resubmitBtnTitle: '',
        footerMessage: 'Access your original file to correct errors. Submit a corrected file.'
    }">
    <div class="error-table">
        <div class="error-header-row">
            <span class="error-location-hdr">Error&nbsp;Location</span>
            <span class="error-desc-hdr">Description</span>
        </div>
        <div *ngFor="let error of errorDetails" class="error-details-row">
            <span *ngIf="error.errorLocation === 'Sample '.concat(modalSampleId)" class="error-location-cell">{{error.errorLocation}}</span>
            <span *ngIf="error.errorLocation === 'Sample '.concat(modalSampleId)" class="error-desc-cell">{{error.errorDescription}}</span>
        </div>
    </div>
</modal-component>


<pandora-aside [title]="'Submission Info'" [isToggleAvailable]=true></pandora-aside>
